(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.EditRolesController = (function(superClass) {
    extend(EditRolesController, superClass);

    function EditRolesController(scope, transitions, modalInstance, service, roles) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.save = bind(this.save, this);
      this.checkViewAll = bind(this.checkViewAll, this);
      this.changeMakeCorp = bind(this.changeMakeCorp, this);
      this.changeIsPendingAdvisor = bind(this.changeIsPendingAdvisor, this);
      this.changeIsAdvisor = bind(this.changeIsAdvisor, this);
      EditRolesController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.changeIsAdvisor = this.changeIsAdvisor;
      this.scope.changeIsPendingAdvisor = this.changeIsPendingAdvisor;
      this.scope.changeMakeCorp = this.changeMakeCorp;
      this.scope.checkViewAll = this.checkViewAll;
      if (roles.data.status.type === 'success') {
        this.scope.user = roles.data.data.user;
        this.scope.companies_users = roles.data.data.companies_users;
      } else {
        this.scope.no_user_message = contact.data.status.msg;
      }
    }

    EditRolesController.prototype.changeIsAdvisor = function(cu) {
      if (cu.is_advisor === true) {
        cu.is_pending_advisor = false;
        cu.make_corp = false;
      }
      return this.checkViewAll(cu);
    };

    EditRolesController.prototype.changeIsPendingAdvisor = function(cu) {
      if (cu.is_pending_advisor === true) {
        cu.is_advisor = false;
        cu.make_corp = false;
      }
      return this.checkViewAll(cu);
    };

    EditRolesController.prototype.changeMakeCorp = function(cu) {
      if (cu.make_corp === true) {
        cu.is_advisor = false;
        cu.is_pending_advisor = false;
        cu.is_view_all = true;
      }
      return this.checkViewAll(cu);
    };

    EditRolesController.prototype.checkViewAll = function(cu) {
      if (cu.make_corp) {
        return false;
      }
      if (cu.is_advisor === false && cu.is_pending_advisor === false) {
        cu.is_view_all = false;
        return false;
      }
      return true;
    };

    EditRolesController.prototype.save = function() {
      this.setAlert({
        type: 'success',
        msg: 'Saving...'
      });
      return this.service.updateRoles(this.scope.user, this.scope.companies_users).then((function(_this) {
        return function() {
          return _this.modalInstance.close();
        };
      })(this));
    };

    return EditRolesController;

  })(DialogController);

}).call(this);
